module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/ClanSupplyFooter/images/footer_bg_get_rewards.e53632c4.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/ClanSupplyFooter/images/footer_bg_get_rewards.png
// module id = 2937
// module chunks = 11